import { Edit, NumberInput, SimpleForm, TextInput } from "react-admin";

export function FaqEdit() {
  return (
    <Edit>
      <SimpleForm>
        <TextInput source="question" fullWidth />
        <TextInput source="answer" fullWidth />
        <NumberInput source="serialNumber" min={1} defaultValue={1} />
      </SimpleForm>
    </Edit>
  );
}
